'use client';

import { BigNum, QUOTE_PRECISION_EXP, User } from '@drift-labs/sdk';

export const getTotalAllTimePnlForUserAccount = (
	user: User | undefined,
	excludeFunding = false
) => {
	if (!user) {
		return BigNum.zero(QUOTE_PRECISION_EXP);
	}

	const netBankValue = user.getNetSpotMarketValue();
	const unrealizedPnl = user.getUnrealizedPNL(
		!excludeFunding,
		undefined,
		undefined
	);

	const netUsdValue = netBankValue.add(unrealizedPnl);
	const totalDeposits = user.getUserAccount().totalDeposits;
	const totalWithdraws = user.getUserAccount().totalWithdraws;

	const totalPnl = netUsdValue.add(totalWithdraws).sub(totalDeposits);

	return BigNum.from(totalPnl, QUOTE_PRECISION_EXP);
};
